<script>
import Tooltip2Vue from "@/components/Tooltip2Vue/Tooltip2Vue.vue";
import TreeDots from "@/components/buttons/TreeDots.vue";

export default {
  props: {
    position: {
      type: String,
      default: "bottom",
    },
  },
  components: {
    Tooltip2Vue,
    TreeDots,
  },
};
</script>

<template>
  <Tooltip2Vue :position="position">
    <slot name="button">
      <TreeDots />
    </slot>
    <template #tooltip>
      <div class="tp-board">
        <slot>
          <div>Prueba tooltip</div>
        </slot>
      </div>
    </template>
  </Tooltip2Vue>
</template>

<style scoped>
.tp-board {
  background-color: var(--lego-bg);
  border-radius: 0.5rem;
  border: solid 1px rgba(255, 255, 255, 0.1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  font-size: 1rem;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  text-align: center;
  display: flex;
  flex-direction: column;
}

.tp-board > :deep(*) {
  display: block;
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: 0.3s;
}
.cancel-default-styles .tp-board > :deep(*) {
  cursor: default;
}

.tp-board > :deep(*):hover {
  background-color: var(--lego-shadow-hover);
  border-radius: 0.5rem;
}
.dark .tp-board > :deep(*):hover {
  background-color: var(--lego-dark-hover);
}

.cancel-default-styles .tp-board > :deep(*):hover {
  background-color: transparent;
}

/* Estilos para elementos de texto */
.tp-board > :deep(*) > span,
.tp-board > :deep(*) > div {
  flex: 1;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  line-height: 1.4;
}

/* Estilos específicos para contenido de diálogo */
.tp-board > :deep(.dialog-content) {
  padding: 1rem;
  line-height: 1.5;
  display: block;
}

.tp-board > :deep(.dialog-title) {
  font-weight: 600;
  margin-bottom: 0.75rem;
  font-size: 1.1rem;
  display: block;
}

.tp-board > :deep(.dialog-message) {
  margin-bottom: 1rem;
  color: rgba(255, 255, 255, 0.8);
  display: block;
}

/* Estilos para tooltips que contienen diálogos */
.tp-board > :deep(.tooltip-dialog) {
  display: block;
  text-align: left;
  padding: 1rem;
  min-height: auto;
  border-bottom: none;
  cursor: default;
}

.tp-board > :deep(.tooltip-dialog) > * {
  display: block;
  margin-bottom: 0.5rem;
}

.tp-board > :deep(.tooltip-dialog) > *:last-child {
  margin-bottom: 0;
}
</style>
